/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type EmployeeHistoricalActivityTimelineQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  clientEmployeeId: Types.Scalars['UUID']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  startDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  endDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type EmployeeHistoricalActivityTimelineQuery = { __typename: 'Query', clientEmployee?: { __typename: 'ClientEmployeeType', id: string, historicalActivities?: { __typename: 'ClientEmployeeHistoricalActivityConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ClientEmployeeHistoricalActivityEdge', node?: { __typename: 'ClientEmployeeHistoricalActivityType', id: string, timestamp: string, eventType: Types.HistoricalActivityEventTypeEnum, description: string, application?: { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, publicResource: { __typename: 'ResourceType', id: string, productName?: string | null, signedLogoUrl?: string | null } } } | null, notification?: { __typename: 'NotificationType', id: string, notificationType?: Types.NotificationEnum | null } | null } | null } | null> } | null } | null };



export const EmployeeHistoricalActivityTimelineDocument = `
    query EmployeeHistoricalActivityTimeline($clientId: UUID!, $clientEmployeeId: UUID!, $first: Int, $after: String, $startDate: DateTime, $endDate: DateTime) {
  clientEmployee(id: $clientEmployeeId, clientId: $clientId) {
    id
    historicalActivities(
      first: $first
      after: $after
      startDate: $startDate
      endDate: $endDate
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          timestamp
          eventType
          description
          application {
            id
            resource {
              id
              publicResource {
                id
                productName
                signedLogoUrl
              }
            }
          }
          notification {
            id
            notificationType
          }
        }
      }
    }
  }
}
    `;

export const useEmployeeHistoricalActivityTimelineQuery = <
      TData = EmployeeHistoricalActivityTimelineQuery,
      TError = unknown
    >(
      variables: EmployeeHistoricalActivityTimelineQueryVariables,
      options?: Omit<UseQueryOptions<EmployeeHistoricalActivityTimelineQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EmployeeHistoricalActivityTimelineQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EmployeeHistoricalActivityTimelineQuery, TError, TData>(
      {
    queryKey: ['EmployeeHistoricalActivityTimeline', variables],
    queryFn: fetcher<EmployeeHistoricalActivityTimelineQuery, EmployeeHistoricalActivityTimelineQueryVariables>(EmployeeHistoricalActivityTimelineDocument, variables),
    ...options
  }
    )};

useEmployeeHistoricalActivityTimelineQuery.getKey = (variables: EmployeeHistoricalActivityTimelineQueryVariables) => ['EmployeeHistoricalActivityTimeline', variables];

export const useInfiniteEmployeeHistoricalActivityTimelineQuery = <
      TData = InfiniteData<EmployeeHistoricalActivityTimelineQuery>,
      TError = unknown
    >(
      variables: EmployeeHistoricalActivityTimelineQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EmployeeHistoricalActivityTimelineQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EmployeeHistoricalActivityTimelineQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<EmployeeHistoricalActivityTimelineQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EmployeeHistoricalActivityTimeline.infinite', variables],
      queryFn: (metaData) => fetcher<EmployeeHistoricalActivityTimelineQuery, EmployeeHistoricalActivityTimelineQueryVariables>(EmployeeHistoricalActivityTimelineDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteEmployeeHistoricalActivityTimelineQuery.getKey = (variables: EmployeeHistoricalActivityTimelineQueryVariables) => ['EmployeeHistoricalActivityTimeline.infinite', variables];


useEmployeeHistoricalActivityTimelineQuery.fetcher = (variables: EmployeeHistoricalActivityTimelineQueryVariables) => fetcher<EmployeeHistoricalActivityTimelineQuery, EmployeeHistoricalActivityTimelineQueryVariables>(EmployeeHistoricalActivityTimelineDocument, variables);
